module.exports = __webpack_public_path__ + "624ecbbc6287376aad0d263d9d6714c0.png";